import useStore from "../../../../common/hooks/useExternalStore";
import { newUserStore } from "../observables/newUserStore";

export const useNewUser = () => {
    const { state } = useStore(newUserStore);

    return state;
};
